import { api } from '../../services/api';
import * as types from '../Constants';

export const getClientActivity = (id) => {
  const options = {
    url: 'v1/client/ClientLog/' + id,
  };

  options.types = [types.CLIENT_ACTIVITY_SUCCESS, types.CLIENT_ACTIVITY_FAILURE];

  return api.get(options);
};

export const getClientActivityParams = (id, data) => {
  const options = {
    url: 'v1/client/activity-logs/' + id,
  };

  options.params = data;

  options.types = [types.CLIENT_ACTIVITY_PARAMS_SUCCESS, types.CLIENT_ACTIVITY_PARAMS_FAILURE];

  return api.get(options);
};

export const getClientActivityLogsPdf = (clientId) => {
  const options = {
    url: 'v1/client/activity-logs-pdf/' + clientId,
  };

  options.types = [
    types.GET_CLIENT_ACTIVITY_LOGS_PDF_SUCCESS,
    types.GET_CLIENT_ACTIVITY_LOGS_PDF_FAILURE,
  ];

  return api.getFile(options);
};

export const addClientActivity = (data) => {
  const options = {
    url: 'v1/client/ClientLog',
  };

  options.types = [types.ADD_CLIENT_ACTIVITY_SUCCESS, types.ADD_CLIENT_ACTIVITY_FAILURE];

  return api.post(options, data);
};
